import { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";

import {
	API_URL,
	createMarkup,
	fmtCurrency,
	getValFromLS,
	setValToLS,
} from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Notice from "../components/Notice";

import DonationForm from "./DonationForm";
import Steps from "./Steps";

/* use as default notice when needed
  type: "notice",
  text: "Sporting Clay Tournament is no longer available",
*/

const Registration = () => {
	const [user, setUser] = useState({});
	const [levels, setLevels] = useState([]);
	const [open, setOpen] = useState([]);
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});
	const [notice] = useState({});

	const { str } = useParams();
	const history = useHistory();

	useEffect(() => {
		const init = async () => {
			const auth = getValFromLS("auth", true)
				? JSON.parse(getValFromLS("auth", true))
				: {};
			const url = new URL(`${API_URL}/registrationInit`);
			const params = {
				q: str ? str : "",
				id: auth.id ? auth.id : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					const auth = {
						id: json.id,
						fname: json.fname,
						email: json.email,
					};
					setValToLS("auth", JSON.stringify(auth), true);
					setUser({ ...auth });
					setLevels(json.levels);
					setAlert({});
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();
	}, [str]);

	const handleToggle = (id) => {
		let newArray = open;
		if (newArray.includes(id)) {
			const index = newArray.indexOf(id);
			if (index > -1) {
				newArray.splice(index, 1);
			}
		} else {
			newArray.push(id);
		}
		setOpen([...newArray]);
	};

	const handleSelect = (id) => {
		let obj = {};
		levels.forEach((item) => {
			if (item.id === id) {
				obj.id = item.id;
				obj.name = item.name;
				obj.amt = item.amt;
				obj.golf = item.golf;
				obj.welcome = item.welcome;
				obj.gift = item.gift;
			}
		});
		setValToLS("order", JSON.stringify({ level: obj }), true);
		history.push("/registration/billing");
	};

	const handleDonation = (amount) => {
		let obj = {};
		levels.forEach((item) => {
			if (item.id === "donation") {
				obj.id = item.id;
				obj.name = item.name;
				obj.amt = amount;
				obj.golf = item.golf;
				obj.welcome = item.welcome;
				obj.gift = item.gift;
			}
		});
		setValToLS("order", JSON.stringify({ level: obj }), true);
		history.push("/registration/billing");
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Sponsor Registration" />
						<div className="blocktext step">
							<h1 style={{ marginBottom: "0" }}>1</h1>
							<div>
								<p>
									Please review and select from the Sponsor Levels below to
									start your registration. You can click the right angle icon to
									reveal additional details about each level.
								</p>

								<p>
									Deadline to register is <strong>March 8, 2027</strong>. Any
									registration submitted after this date will forfeit any logo
									recognition assets.
								</p>

								<p>
									Questions or for more information, please email{" "}
									<a href="mailto:ValeroBFC@valero.com">ValeroBFC@valero.com</a>
									.
								</p>
							</div>
						</div>

						<div className="spacer"></div>

						{notice.type && <Notice data={notice} />}

						{/*<p style={{ fontSize: "1.05rem", fontWeight: "bold" }}>
							**As of February 9, 2025, there are no more guaranteed hotel rooms
							at the JW Marriott. Any registrations after this date will be a
							request only. Requests will be approved/denied after the March 7th
							deadline**
						</p>*/}

						<p style={{ fontSize: "1.05rem" }}>
							Click the chevron icon (<i className="fa fa-angle-right"></i>{" "}
							&nbsp;) to view all assets included in the sponsorship.
						</p>

						<div id="sponsor-packages">
							{levels.map((item) => {
								const hdg =
									item.id === "exclusivesponsor"
										? `${item.name} - ${fmtCurrency(item.amt / 100, 0)}`
										: item.id === "donation"
										? `${item.name}`
										: `${item.name} - ${fmtCurrency(item.amt / 100, 0)}`;

								return (
									<div key={item.id}>
										<button
											type="button"
											className="naked"
											onClick={() => handleToggle(item.id)}
										>
											<h3>
												<span>{hdg}</span>
												<i
													className={
														open.includes(item.id)
															? "fa fa-angle-down fa-2x"
															: "fa fa-angle-right fa-2x"
													}
												/>
											</h3>
										</button>

										<div className={open.includes(item.id) ? "" : "hidden"}>
											<div dangerouslySetInnerHTML={createMarkup(item.html)} />
											{item.qtys.length === 0 ? (
												<span />
											) : item.qtys.length === 1 && item.qtys[0] === 0 ? (
												<Alert
													data={{ type: "error", text: "Sold Out" }}
													inline={true}
												/>
											) : item.id === "donation" ? (
												<DonationForm handleDonation={handleDonation} />
											) : item.qtys.length === 1 ? (
												<div className="qtys">
													<button
														type="button"
														className="btn-alt"
														onClick={() => handleSelect(item.id)}
													>
														{`Select ${item.name}`}
													</button>
												</div>
											) : (
												<div className="qtys">
													<button
														type="button"
														className="btn-alt"
														onClick={() => handleSelect(item.id)}
													>
														{`Select ${item.name}`}
													</button>
													<button
														type="button"
														className="btn-alt"
														onClick={() => handleSelect(item.id)}
													>
														{`Select ${item.name}`}
													</button>
												</div>
											)}
										</div>
									</div>
								);
							})}
						</div>
					</div>

					<div id="right-column">
						<Steps on={1} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Registration;
